// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal .modal {
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto; /* Safari, Chrome and Opera > 12.1 */
  animation: fadeIn 400ms linear;
}
.Modal .gallery-content {
  width: 100%;
  height: 100%;
}
.Modal .gallery-content .close {
  color: white;
  position: absolute;
  top: 40px;
  right: 40px;
}
.Modal .modal-content {
  background-color: white;
  width: 408px;
  max-width: 90%;
  min-height: 250px;
  top: 5%;
  margin: auto;
  padding: 20px;
  border-radius: 20px;
  border: 0;
  text-align: left;
}
.Modal .modal-content .title {
  font-size: 25px;
}
.Modal .modal-content button.yellow-btn {
  padding: 7px 35px;
}
.Modal .close {
  color: #7a7a7a;
  text-align: end;
  float: right;
  font-size: 25px;
  font-weight: bold;
  position: absolute;
  right: 15px;
}
.Modal .close:hover,
.Modal .close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

@media screen and (max-width: 451px) {
  .Modal .modal .modal-content {
    margin-left: 20px;
    width: 100%;
    margin-right: 20px;
  }
}
.Modal .modal-content {
  top: 25% !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.scss"],"names":[],"mappings":"AAGE;EACE,oCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA,EAEA,oCAAA;EACA,8BAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;AAJJ;AAKI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAHN;AAOE;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AALJ;AAOI;EAIE,eAAA;AARN;AAiBM;EACE,iBAAA;AAfR;AAoBE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAlBJ;AAqBE;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AAnBJ;;AAuBA;EAGM;IACE,iBAAA;IACA,WAAA;IACA,kBAAA;EAtBN;AACF;AA0BA;EACE,mBAAA;AAxBF","sourcesContent":["@use \"src/styles/variables\" as vars;\n\n.Modal {\n  .modal {\n    background-color: rgba(0, 0, 0, 0.6);\n    z-index: 10;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    overflow: auto;\n    //padding-top: 80px;\n    -webkit-animation: fadeIn 400ms linear; /* Safari, Chrome and Opera > 12.1 */\n    animation: fadeIn 400ms linear;\n  }\n\n  .gallery-content {\n    width: 100%;\n    height: 100%;\n    .close {\n      color: white;\n      position: absolute;\n      top: 40px;\n      right: 40px;\n    }\n  }\n\n  .modal-content {\n    background-color: white;\n    width: 408px;\n    max-width: 90%;\n    min-height: 250px;\n    top: 5%;\n    margin: auto;\n    padding: 20px;\n    border-radius: 20px;\n    border: 0;\n    text-align: left;\n\n    .title {\n      // margin-top: -20px;\n      // margin-top: unset;\n      // margin-top: -35px;\n      font-size: 25px;\n    }\n\n    // .sub-title {\n    //   margin-top: 0;\n    //   font-size: 20px;\n    // }\n\n    button {\n      &.yellow-btn {\n        padding: 7px 35px;\n      }\n    }\n  }\n\n  .close {\n    color: #7a7a7a;\n    text-align: end;\n    float: right;\n    font-size: 25px;\n    font-weight: bold;\n    position: absolute;\n    right: 15px;\n  }\n\n  .close:hover,\n  .close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n  }\n}\n\n@media screen and (vars.$mobile-media) {\n  .Modal {\n    .modal {\n      .modal-content {\n        margin-left: 20px;\n        width: 100%;\n        margin-right: 20px;\n      }\n    }\n  }\n}\n.Modal .modal-content {\n  top: 25% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
